<template>
  <div class="select-city">
    <ErrorScreen v-if="errored" />
    <LoadingScreen v-if="loading" />

    <section v-if="!loading && !errored">
      <v-list two-line>
        <v-list-item
          v-for="city in cities"
          :key="city._id"
          @click="selectCity(city._id)"
        >
          <v-list-item-avatar>
            <v-avatar color="grey" size="40">
              <span class="white--text headline">{{
                city.name.charAt(0).toUpperCase()
              }}</span>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ city.name }}</v-list-item-title>
            <v-list-item-subtitle>{{
              city.location.federalState
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </section>
  </div>
</template>

<script>
import ErrorScreen from "@/components/ErrorScreen.vue";
import LoadingScreen from "@/components/LoadingScreen.vue";

export default {
  name: "SelectCity",

  components: {
    ErrorScreen,
    LoadingScreen
  },

  data: function() {
    return {
      loading: true,
      errored: false
    };
  },

  computed: {
    cities: function() {
      return this.$store.getters["cities/all"]();
    }
  },

  methods: {
    selectCity: function(cityId) {
      localStorage.setItem(this.$localStorageKeys.CITY_ID, cityId);
      this.$router.push({
        name: "Home",
        params: {
          cityId: cityId
        }
      });
    }
  },

  created() {
    let that = this;
    this.$store
      .dispatch("cities/fetchAll")
      .catch(e => {
        console.log(e);
        that.errored = true;
      })
      .finally(() => (that.loading = false));
  },

  mounted() {
    let cityId = localStorage.getItem(this.$localStorageKeys.CITY_ID);
    if (this.$route.params.noRedirect == null && cityId != null) {
      this.$router.push({
        name: "Home",
        params: {
          cityId: cityId
        }
      });
    }
  }
};
</script>
